module.exports = __webpack_public_path__ + "static/img/act-steps-m-2-hk.fba03b4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/act-steps-m-2-hk.png
// module id = nWAH
// module chunks = 1